$(function() {
	$('.js-carousel-main').slick({
		slidesToShow: 1,
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 800,
		lazyLoad: 'progressive', //'ondemand'
		fade: true,
		infinite: true,
		pauseOnHover: false,
		easing: 'easeOutQuad'
	});

	// fit carousel to window bottom
	var wh = window.innerHeight;
	var hh = $('.st-header').height();
	var jh = wh - hh;
	$('.top-jambotron').height(jh);
	$('.js-carousel-main .slick-slide').height(jh);
	// imageをbgimgに入れ替え
	$('.js-carousel-main').on('lazyLoaded', function(event, slick, image, imageSource){
		image.hide();
		$(image.parent()).css({
		  'background-image': 'url(' + imageSource + ')',
		  'background-size': 'cover',
		  'background-position': 'center'
		});
	});

});